/// <reference path="../../app.definition.ts" />

import angular from 'angular';
import * as _ from 'lodash';
import { User } from '@common/model/user';
import { Subject } from '@common/model/subject';
import { CacheService } from '@common/service/cache.service';
import { PopUpService } from '@common/popup/popup.service';
import { JavaApiAdapterService } from '@common/apiadapter/javaapi.service';
import { IAppRootScopeService } from '@/app/app.definition';

export interface IUserService {
    isUserTeammember(subjectId): any;
    getMe(): User;
    getCopyOfMe(): User;
    getMyId(): number;
    openMemberProfile(user: User, mode: string, subjectId: Subject): void
    reset(): void;
    allowCstmAttr(subject?: Subject): boolean;
    schools;
    getOrgSchools();
}

export class UserService implements IUserService {
    user: User;
    userId: number;
    schools = {};

    static $inject = ["$rootScope", "CacheService", "PopUpService", "ApiAdapterService", "$q"];

    constructor(
        private $rootScope: IAppRootScopeService,
        private $_cache: CacheService,
        private $_pop: PopUpService,
        private $_api: JavaApiAdapterService,
        private $q
    ) { }

    getMe(): User {
        return (this.user = this.user || this.$_cache.getUser() || null);
    }

    getCopyOfMe(): User {
        var user: User = (this.user = this.user || this.$_cache.getUser() || null);
        if (!!user) {
            return new User().deserialize(user);
        }
        return null;
    }

    getMyId(): number {
        if (!!this.userId && this.userId > -1) {
            return this.userId;
        }
        return (this.userId = this.$_cache.getUser().userId || -1);
    }

    openMemberProfile(user: User, mode: string, subject: Subject): void {
        console.log('viewTeamMember', user, subject);
        this.$rootScope.mainShowLoader = true;
        var that = this;

        this.$_pop.openMemberProfile(user, 'view', subject).then(s => {
            // invite successfully sent
            if (!!s && !!s.user) {
                new User().deserialize(s.user);
            }

            that.$rootScope.mainShowLoader = false;
        }, (e) => {
            that.$rootScope.mainShowLoader = false;
            if (e) that.$_pop.openInformationModal(e);

        });
        return;
    }

    isUserTeammember = (s): any => {
        var deferred = this.$q.defer();
        deferred.resolve(s.subjectId && (s.isActiveMember || (s.isTeamMember && !s.isFormerTeamMember)))
        return deferred.promise;
    }

    reset(): void {
        this.user = null;
        this.userId = -1;
    }

    allowCstmAttr = (subject?: Subject) => {
        let features = this.$_cache.getFeatures();
        let allow = !!features ? features.customAttributes : false;
        if (allow && !!subject && !!subject.teamOrgShortName) {
            let user = this.$_cache.getUser();
            let userOrg = !!user.organizationShortName ? user.organizationShortName.toUpperCase() : null;
            if (subject.teamOrgShortName.toUpperCase() == userOrg) {
                allow = true;
            } else {
                allow = false;
            }
        }
        return allow;
    }

    getOrgSchools = () => {
        let user = this.$_cache.getUser();
        if (user.organizationId) {
            this.$_api.getSchoolsForReport(user.organizationId).then(data => {
                this.schools = _.reduce(data, (ac, obj) => {
                    ac[obj['id']] = obj['label'];
                    return ac;
                }, {});
            })
        }
    }
}

angular.module('eCareVault.common.services')
    .service('UserService', UserService);